import { COTIZACIONES } from '../actions/types';

const normalize = (val) => {
    if (val === null || val === undefined) return '';
    const sinAcentos = (val + '').toLowerCase().normalize('NFD');
    let resultado = '';
    for (let i = 0; i < sinAcentos.length; i++) {
        const code = sinAcentos.charCodeAt(i);
        if (code < 0x0300 || code > 0x036f) {
            resultado += sinAcentos[i];
        }
    }
    return resultado.trim();
};

const initialState = {
    listado: [],
    filtrado: [],
    error: null,

    detalle: null,
    loadingDetalle: false
};

export default function cotizacionesReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case COTIZACIONES.LISTAR: {
            const listado = Array.isArray(payload) ? payload : [];
            return {
                ...state,
                listado,
                filtrado: listado,
                error: null
            };
        }

        case COTIZACIONES.FILTRAR: {
            const texto = normalize(payload);
            if (!texto) {
                return { ...state, filtrado: state.listado };
            }

            const filtrado = state.listado.filter((c) => {
                const folio = normalize(c?.folio);
                const proyecto = normalize(c?.proyecto?.nombre);
                const nombre = normalize(c?.nombre);

                return folio.includes(texto) || proyecto.includes(texto) || nombre.includes(texto);
            });

            return { ...state, filtrado };
        }

        case COTIZACIONES.LIMPIAR:
            return { ...initialState };

        case COTIZACIONES.DETALLE_CARGANDO:
            return {
                ...state,
                detalle: null,
                loadingDetalle: true
            };

        case COTIZACIONES.DETALLE:
            return {
                ...state,
                detalle: payload || null,
                loadingDetalle: false
            };

        case COTIZACIONES.LIMPIAR_DETALLE:
            return {
                ...state,
                detalle: null,
                loadingDetalle: false
            };

        case COTIZACIONES.ERROR:
            return { ...state, error: payload, loadingDetalle: false };

        default:
            return state;
    }
}
